export default __webpack_public_path__ + "8f9da85f7c4a276229b016f34dfb7182.png";